import { CartState } from '@monolith/legacy/store/cart';
import { Store } from 'vuex';
import Product from '@monolith/legacy/types/product';
import { getCart } from '@monolith/legacy/modules/cart-2/service';
import { findPurchasableItemByVariantId } from '@monolith/legacy/modules/cart-2/utilities/cart';

export class CanAddFirstVariantToCartUseCase {
  constructor(private readonly store: Store<{ cart: CartState }>) {}

  /**
   * Check if a variant can be added to the current cart.
   *
   * @param variant - The variant to check. The stock of this variant will be checked.
   * @param cartItemQuantity - The cart item quantity to check.
   *
   * @returns A promise that resolves to true if the variant can be added to the cart, false otherwise.
   */
  async execute(product: Pick<Product, 'variants' | 'unit_multiplier'>, cartItemQuantity: number): Promise<boolean> {
    const variant = product?.variants?.[0];

    if (!variant) {
      return false;
    }
    const retailer = this.store.getters['retailer'];
    const cart = await getCart(retailer.cart_uuid);
    const variantInCart = findPurchasableItemByVariantId(cart, variant.uuid);
    const unitMultiplier = variant.unit_multiplier ?? product.unit_multiplier;
    const hasEnoughStock =
      variant.stock.is_always_in_stock
      || variant.stock.inventory_policy === 'continue'
      || variant.stock.available_quantity >= cartItemQuantity * unitMultiplier;
    return hasEnoughStock && (!variantInCart || variantInCart?.quantity < cartItemQuantity);
  }
}
